import { Form, FormInstance } from 'antd';
import { CrudFilters } from '@refinedev/core/dist/interfaces';
import Cw8Field from 'components/cw8/Cw8Field';
import { FieldDB } from 'interfaces/schemaDB';
import { FormMode } from 'interfaces/interfaces';

interface TabGeneralProps {
    fieldList: FieldDB[];
    filterList?: CrudFilters | undefined;
    record?: unknown;
    formMode : FormMode;
    resourceName: string;
    form: FormInstance;
}

export const TabGeneral = ({ fieldList, resourceName, form, filterList, record, formMode}: TabGeneralProps) => {
  return (
    <Form>
        {
            fieldList.map((field) => (
                <Cw8Field
                    key = {field.name}
                    field = {field}
                    filterList = {filterList}
                    record = {record}
                    formMode = {formMode}
                    resourceName = {resourceName}
                    form = {form}
                ></Cw8Field>
            ))
        }
    </Form>
  )
}